import React, { useState } from 'react';
import Layout from '../components/Layout'; 

const NumberCalculator = () => {
    const [inputValue, setInputValue] = useState('');
    const [result, setResult] = useState(null);
    const [preview, setPreview] = useState('');
    const [count, setCount] = useState(0); 
    const [error, setError] = useState('');

    // সব ডেটা ক্লিয়ার করার ফাংশন
    const handleReset = () => {
        setInputValue('');
        setResult(null);
        setPreview('');
        setCount(0);
        setError('');
    };

    const processNumbers = (operator) => {
        setError('');
        setResult(null);
        setPreview('');
        setCount(0);

        const parts = inputValue.trim().split(/\s+/);

        if (inputValue.trim() === "") {
            setError("দয়া করে কিছু নম্বর ইনপুট দিন!");
            return;
        }

        let numbers = [];
        let previewParts = [];
        let hasError = false;

        for (let i = 0; i < parts.length; i++) {
            const currentPart = parts[i];
            const num = Number(currentPart);

            if (isNaN(num) || currentPart === "") {
                setError(`Recheck: ${i + 1} নম্বর ডেটাতে সমস্যা আছে ("${currentPart}")`);
                hasError = true;
                break;
            }
            numbers.push(num);
            previewParts.push(currentPart);
        }

        if (!hasError && numbers.length > 0) {
            setPreview(previewParts.join(operator));
            setCount(numbers.length); 
            
            const total = numbers.reduce((acc, curr) => {
                const nextValue = operator === '+' ? acc + curr : acc - curr;
                return Math.round((nextValue + Number.EPSILON) * 100) / 100;
            });
            setResult(total);
        }
    };

    return (
        <Layout>
            <div style={{ padding: '20px', maxWidth: '700px', margin: '20px auto' }}>
                <div style={{ background: 'white', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
                    <h3 style={{ color: '#0f172a', fontWeight: '800', marginBottom: '20px', textAlign: 'center' }}>
                        Quick Number Calculator
                    </h3>
                    
                    <div style={{ display: 'flex', gap: '15px', marginBottom: '20px', justifyContent: 'center' }}>
                        <button 
                            onClick={() => processNumbers('+')}
                            style={{ padding: '12px 30px', fontSize: '24px', cursor: 'pointer', background: '#10b981', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold' }}
                        > + </button>
                        
                        <button 
                            onClick={() => processNumbers('-')}
                            style={{ padding: '12px 30px', fontSize: '24px', cursor: 'pointer', background: '#f43f5e', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold' }}
                        > - </button>

                        {/* 🔥 Reset Button Added */}
                        <button 
                            onClick={handleReset}
                            style={{ padding: '12px 20px', fontSize: '16px', cursor: 'pointer', background: '#64748b', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold' }}
                        > Reset </button>
                    </div>

                    <label style={{ fontSize: '13px', fontWeight: '700', color: '#64748b', display: 'block', marginBottom: '8px' }}>
                        Enter Numbers (Separated by Space)
                    </label>
                    <textarea
                        placeholder="Ex: 150 50 90 10"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        style={{ width: '100%', height: '120px', padding: '15px', fontSize: '18px', borderRadius: '8px', border: '2px solid #e2e8f0', boxSizing: 'border-box', outline: 'none', fontFamily: 'monospace' }}
                    />

                    {error && (
                        <div style={{ marginTop: '20px', padding: '15px', background: '#fee2e2', color: '#dc2626', borderRadius: '8px', borderLeft: '5px solid #ef4444', fontWeight: '600' }}>
                            ⚠️ {error}
                        </div>
                    )}

                    {(preview || result !== null) && !error && (
                        <div style={{ marginTop: '25px', padding: '20px', background: '#f8fafc', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
                            <div style={{ marginBottom: '15px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ fontSize: '12px', fontWeight: '800', color: '#64748b', textTransform: 'uppercase' }}>
                                        Format Preview
                                    </span>
                                    <span style={{ background: '#0284c7', color: 'white', padding: '2px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '900' }}>
                                        TOTAL ITEMS: {count}
                                    </span>
                                </div>
                                <div style={{ fontSize: '20px', wordBreak: 'break-all', fontWeight: '700', color: '#334155', marginTop: '8px' }}>
                                    {preview}
                                </div>
                            </div>
                            
                            <div style={{ borderTop: '2px dashed #cbd5e1', paddingTop: '15px' }}>
                                <span style={{ fontSize: '12px', fontWeight: '800', color: '#0284c7', textTransform: 'uppercase' }}>Total Calculation:</span>
                                <div style={{ fontSize: '32px', fontWeight: '900', color: '#0f172a', marginTop: '5px' }}>
                                    {result.toLocaleString()}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
};

export default NumberCalculator;
